import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  where,
} from 'firebase/firestore';
import { db } from '../../firebase';
import './CirclePostList.css';

function formatDate(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('ja-JP', { month: 'short', day: 'numeric' });
}

function CirclePostList({ circleId, isOwner, maxItems = 6 }) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!circleId) return;
    let active = true;
    setLoading(true);

    const conditions = [
      where('status', 'in', ['published', ...(isOwner ? ['draft'] : [])]),
      orderBy('createdAt', 'desc'),
      limit(maxItems),
    ];

    getDocs(query(collection(db, 'recruitments', circleId, 'posts'), ...conditions))
      .then((snap) => {
        if (!active) return;
        setPosts(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      })
      .catch((err) => console.error('CirclePostList fetch failed:', err))
      .finally(() => { if (active) setLoading(false); });

    return () => { active = false; };
  }, [circleId, isOwner, maxItems]);

  if (loading) return <p className="cpl-loading">読み込み中...</p>;

  return (
    <div className="cpl-container">
      {isOwner && (
        <div className="cpl-header">
          <Link to={`/circles/${circleId}/posts/new`} className="cpl-new-btn">
            + 活動記録を投稿
          </Link>
        </div>
      )}

      {posts.length === 0 ? (
        <p className="cpl-empty">
          {isOwner
            ? 'まだ活動記録がありません。山行後に記録を残しましょう。'
            : 'まだ活動記録がありません。'}
        </p>
      ) : (
        <ul className="cpl-list">
          {posts.map((post) => (
            <li key={post.id} className="cpl-item">
              <Link to={`/circles/${circleId}/posts/${post.id}`} className="cpl-item__link">
                {post.photoUrls?.[0] && (
                  <div className="cpl-item__thumb">
                    <img src={post.photoUrls[0]} alt={post.mountain} />
                  </div>
                )}
                <div className="cpl-item__body">
                  <div className="cpl-item__meta">
                    <span className="cpl-item__date">{formatDate(post.date)}</span>
                    {post.status === 'draft' && <span className="cpl-item__draft">下書き</span>}
                  </div>
                  <p className="cpl-item__title">{post.title || post.mountain}</p>
                  {post.mountain && post.title && (
                    <p className="cpl-item__mountain">{post.mountain}</p>
                  )}
                </div>
              </Link>
            </li>
          ))}
        </ul>
      )}

      {posts.length >= maxItems && (
        <Link to={`/circles/${circleId}/posts`} className="cpl-more">
          すべての活動記録を見る
        </Link>
      )}
    </div>
  );
}

export default CirclePostList;
